import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_SYNC_COMMIT } from "./gql";

const useStackSyncCommit = createDefaultMutationHook(STACK_SYNC_COMMIT);
export const useBulkStackSyncCommit = createBulkMutationHook(STACK_SYNC_COMMIT);

export default useStackSyncCommit;
